import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Empty } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import ESignDialog from "@/components/ESignDialog";
import { FileSignature, Loader2, Download, CheckCircle2, PenLine } from "lucide-react";

const C_COLOR = { sent: "#F5A623", signed: "#10B981", void: "#71717A", draft: "#71717A" };

export default function ClientContracts() {
  const [contracts, setContracts] = useState(null);
  const [signing, setSigning] = useState(null);
  const load = () => api.get("/contracts").then(({ data }) => setContracts(data));
  useEffect(() => { load(); }, []);

  return (
    <div>
      <PageHeader overline="Agreements to review & sign" title="Contracts" />
      <div className="p-8">
        {!contracts && <div className="flex justify-center py-24"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>}
        {contracts && contracts.length === 0 && <Empty icon={FileSignature} title="No contracts yet" hint="Agreements your recruiter sends will appear here for review and e-signature." />}
        {contracts && contracts.length > 0 && (
          <div className="space-y-px bg-black/10 border border-black/10">
            {contracts.map((c) => (
              <div key={c.id} className="bg-white p-5 flex items-center justify-between" data-testid={`ccontract-${c.id}`}>
                <div>
                  <p className="font-medium capitalize">{(c.contract_type || "").replace(/_/g, " ")}</p>
                  <p className="overline text-[0.55rem] mt-1">{c.filename}{c.signer_name ? ` · signed by ${c.signer_name}` : ""}</p>
                </div>
                <div className="flex items-center gap-4">
                  <span className="flex items-center gap-1.5 text-xs capitalize"><span className="h-1.5 w-1.5 rounded-full" style={{ background: C_COLOR[c.status] || "#71717A" }} />{c.status}</span>
                  <a href={`${process.env.REACT_APP_BACKEND_URL}${c.file_url}`} target="_blank" rel="noreferrer" className="p-2 border border-black/10 hover:bg-black/5 transition-colors" title="Download"><Download className="h-4 w-4" /></a>
                  {c.status === "signed" ? (
                    <span className="flex items-center gap-1 text-xs text-[#10B981]"><CheckCircle2 className="h-4 w-4" /> Signed</span>
                  ) : (
                    <Button size="sm" onClick={() => setSigning(c)} data-testid={`csign-${c.id}`} className="rounded-none bg-primary hover:bg-[#09090B]"><PenLine className="h-4 w-4 mr-1" /> Review & sign</Button>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <ESignDialog contract={signing} open={!!signing} onOpenChange={(o) => !o && setSigning(null)} onSigned={() => { setSigning(null); load(); }} />
    </div>
  );
}
